<template>
  <el-dialog
      title="司机信息"
      width="600px"
      destroy-on-close
      :visible.sync="showDialog"
      :before-close="handleClose">
    <div>
      <el-form :model="form"  :rules="rules" ref="form" label-width="166px">

        <el-form-item label="性别" prop="driverGender">
          <el-radio-group v-model="form.driverGender">
            <el-radio label="男"></el-radio>
            <el-radio label="女"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="民族" prop="nation">
          <el-input style="width: 100%" type="text" placeholder="请输入民族(同身份证)" maxlength="20"
                    v-model="form.nation"></el-input>
        </el-form-item>

        <el-form-item label="身份证签发机关" prop="idcardSignsBy">
          <el-input type="text" placeholder="请输入身份证签发机关(同身份证)" maxlength="50"
                    v-model="form.idcardSignsBy"></el-input>
        </el-form-item>
        <el-form-item label="准驾车型" prop="licenseType">
          <el-select v-model="form.licenseType" filterable>
            <el-option label="大型客车-A1" value="A1"></el-option>
            <el-option label="牵引车-A2" value="A2"></el-option>
            <el-option label="城市公交车-A3" value="A3"></el-option>
            <el-option label="中型客车-B1" value="B1"></el-option>
            <el-option label="大型货车-B2" value="B2"></el-option>
            <el-option label="小型汽车-C1" value="C1"></el-option>
            <el-option label="小型汽车-C1" value="C1"></el-option>
            <el-option label="小型自动挡汽车-C2" value="C2"></el-option>
            <el-option label="低俗载货汽车-C3" value="C3"></el-option>

          </el-select>
        </el-form-item>

        <el-form-item label="驾驶证有效期起" prop="drvLicenseDateStart">
          <el-date-picker
              style="width: 100%"
              v-model="form.drvLicenseDateStart"
              type="date"
              value-format="timestamp"
              placeholder="请选择驾驶证有效期起">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="驾驶证有效期止" prop="driverLicenseDateEnd">
          <el-date-picker
              style="width: 100%"
              v-model="form.driverLicenseDateEnd"
              type="date"
              value-format="timestamp"
              placeholder="请选择驾驶证有效期止">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="从业资格证号" prop="licenseNumber">
          <el-input style="width: 100%" type="text" placeholder="请输入从业资格证号" maxlength="50"
                    v-model="form.licenseNumber"></el-input>
        </el-form-item>

        <el-form-item label="是否具备客运资格类别" prop="licensePassengerTrans">
          <el-radio-group v-model="form.licensePassengerTrans">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>


    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onsubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: "supervise",
  components: {},
  data() {
    return {
      showDialog: false,
      form: {
        driverGender: "男",
        nation: "",
        idcardSignsBy: "",
        licenseType: "",
        drvLicenseDateStart: "",
        driverLicenseDateEnd: "",
        licenseNumber: "",
        licensePassengerTrans: 1,
      },
      rules: {
        driverGender: [{required: true, message: '请选择性别', trigger: ['blur', 'change']}],
        nation: [{required: true, message: '请输入民族', trigger: ['blur', 'change']}],
        idcardSignsBy: [{required: true, message: '请输入身份证签发机关', trigger: ['blur', 'change']}],
        licenseType: [{required: true, message: '请输入准驾车型', trigger: ['blur', 'change']}],
        drvLicenseDateStart: [{required: true, message: '请选择有效期起', trigger: ['blur', 'change']}],
        driverLicenseDateEnd: [{required: true, message: '请选择有效期止', trigger: ['blur', 'change']},
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请选择有效期止'))
              } else if (value <= this.form.drvLicenseDateStart) {
                callback(new Error('有效结束时间请大于开始有效时间!'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }],

        licenseNumber: [{required: true, message: '请输入从业资格证号', trigger: ['blur', 'change']}],
        licensePassengerTrans: [{required: true, message: '请选择协议是否终止', trigger: ['blur', 'change']}],


      }
    }
  },
  props: {
    value: {
      default: false
    },
    driverData: {
      default: {}
    }
  },
  watch: {
    value() {
      this.showDialog = this.value
      this.showDialog && this.getInitMerchantFn()
    }
  },
  methods: {
    async getInitMerchantFn() {
      const {code, data} = await this.$axios.get('/api/v1/manage/driver/survey', {
        driverId: this.driverData.id
      })
      if (code === 1 && data) {
        this.form = {
          ...this.form,
          ...data,
          drvLicenseDateStart: new Date(data.drvLicenseDateStart).getTime(),
          driverLicenseDateEnd: new Date(data.driverLicenseDateEnd).getTime(),
        }
      }
    },
    updateUrls() {
      this.$refs.form.validateField('platformAgreementPdf')
    },
    handleClose() {
      this.form = {
        driverGender: "男",
        nation: "",
        idcardSignsBy: "",
        licenseType: "",
        drvLicenseDateStart: "",
        driverLicenseDateEnd: "",
        licenseNumber: "",
        licensePassengerTrans: 1,
      }
      this.$emit('input', false)
    },
    onsubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const url = '/api/v1/manage/driver/survey'
          const params = {

            ...this.form,
            driverId: this.driverData.id,
            drvLicenseDateStart: this.$utils.timeFn(this.form.drvLicenseDateStart, 'YYYY-MM-DD'),
            driverLicenseDateEnd: this.$utils.timeFn(this.form.driverLicenseDateEnd, 'YYYY-MM-DD'),
          }
          const {code} = await this.$axios.post(url, params)
          if (code === 1) {
            this.$message.success('操作成功')
            this.handleClose()
          }
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>

</style>